export default {
    methods: {
        L(value, source, ...argus) {
            if (source) {
                return window.abp.localization.localize(value, source, argus);
            } else {
                return window.abp.localization.localize(value, "UePP", argus);
            }

        },
        hasPermission(permissionName) {
            return window.abp.auth.hasPermission(permissionName);
        },
        hasAnyOfPermissions(...argus) {
            return window.abp.auth.hasAnyOfPermissions(...argus);
        },
        hasAllOfPermissions(...argus) {
            return window.abp.auth.hasAllOfPermissions(...argus);
        },
        isFeatureEnabled(name) {
            return window.abp.features.isEnabled(name);
        },
        isIntranetFeatureEnabled() {
            return this.isFeatureEnabled("Intranet");
        },
        getSettingsValue(key) {
            return window.abp.setting.get(key);
        }
    }
}